import { cookieChannel } from '@fingoti/auth-js/org-sync';

// Shares the active org-context chain (org ids only — never tokens) across the
// Fingoti apps that live on the same registrable domain, so a switch / act-as
// or exit in one app follows the user into the others.
//
// Domain rules mirror the existing cross-app cookieSettings in config.jsx:
//   LOCAL → host-only + insecure (http://localhost; no real cross-app sharing)
//   DEV   → .fingoti.net
//   PROD  → .fingoti.com
const envString = process.env.REACT_APP_ENVIROMENT_STRING;

const channelOptions =
	envString === 'LOCAL'
		? { secure: false }
		: { domain: envString === 'DEV' ? '.fingoti.net' : '.fingoti.com' };

// Module scope: useOrgContextSync needs a stable channel identity across renders.
export const orgContextChannel = cookieChannel(channelOptions);
